import { render, staticRenderFns } from "./IndiaH5Extra.vue?vue&type=template&id=6667519a"
import script from "./IndiaH5Extra.vue?vue&type=script&lang=ts"
export * from "./IndiaH5Extra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports